/**
 * Single Disbursement Tour Configuration
 * 
 * Tour guide for the Single Disbursement tab only.
 */

export const getSingleDisbursementTourSteps = (t) => {
  // Helper function to check if an element exists in the DOM
  const elementExists = (selector) => {
    if (typeof document === 'undefined') {return false;}
    const element = document.querySelector(selector);
    return element !== null && element.offsetParent !== null;
  };

  // Base steps that always appear
  const baseSteps = [
    // Tabs section - positioned to highlight the tab buttons
    {
      selector: '[data-tour="disbursements-tabs"]',
      content: t('tour.disbursements.tabs', {
        ns: 'common',
        defaultValue: 'Choose between Single or Bulk disbursement mode.'
      }),
      position: 'bottom',
      styles: {
        popover: (base) => ({
          ...base,
          marginTop: '-10px'
        }),
        maskWrapper: (base) => ({
          ...base,
          transform: 'translateY(-27px)'
        }),
        maskArea: (base) => ({
          ...base,
          transform: 'translateY(-27px)'
        })
      }
    }
  ];

  // Single disbursement form steps
  const singleFormSteps = [
    // Source Account Section
    {
      selector: '[data-tour="disbursements-source-account"]',
      content: t('tour.disbursements.sourceAccount', {
        ns: 'common',
        defaultValue: 'Select the account to disburse from (wallet balance).'
      }),
      position: 'bottom'
    },
    
    // Payment Details Section
    {
      selector: '[data-tour="disbursements-payment-details"]',
      content: t('tour.disbursements.paymentDetails', {
        ns: 'common',
        defaultValue: 'Enter payment amount and purpose/narration.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-amount"]',
      content: t('tour.disbursements.amount', {
        ns: 'common',
        defaultValue: 'Set the amount you want to send to the recipient.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-purpose"]',
      content: t('tour.disbursements.purpose', {
        ns: 'common',
        defaultValue: 'Add a purpose or narration for this disbursement.'
      }),
      position: 'bottom'
    },
    
    // Destination Account Section
    {
      selector: '[data-tour="disbursements-destination-account"]',
      content: t('tour.disbursements.destinationAccount', {
        ns: 'common',
        defaultValue: 'Select payment method and enter recipient details.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-payment-method"]',
      content: t('tour.disbursements.paymentMethod', {
        ns: 'common',
        defaultValue: 'Choose how to send the money (Mobile Money or Bank).'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-recipient-name"]',
      content: t('tour.disbursements.recipientName', {
        ns: 'common',
        defaultValue: 'Recipient name details appear here after fetching account information.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-phone-number"]',
      content: t('tour.disbursements.phoneNumber', {
        ns: 'common',
        defaultValue: 'Enter the recipient phone number for Mobile Money verification.'
      }),
      position: 'bottom'
    },
    {
      selector: '[data-tour="disbursements-provider"]',
      content: t('tour.disbursements.provider', {
        ns: 'common',
        defaultValue: 'Select the Mobile Money provider for the recipient.'
      }),
      position: 'bottom'
    }
  ];

  // History list (always shown)
  const historyStep = {
    selector: '[data-tour="disbursements-list"]',
    content: t('tour.disbursements.list', {
      ns: 'common',
      defaultValue: 'View and manage past disbursements.'
    }),
    position: 'bottom'
  };

  // Build steps array - filter to only include existing elements
  const allSteps = [...baseSteps];
  allSteps.push(...singleFormSteps.filter(step => elementExists(step.selector)));
  
  // Always add history step if it exists
  if (elementExists(historyStep.selector)) {
    allSteps.push(historyStep);
  }

  return allSteps;
};

